var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJordan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_763)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 39.9999C31.0458 39.9999 40.0001 31.0456 40.0001 19.9999C40.0001 8.95418 31.0458 -0.00012207 20.0001 -0.00012207C8.95443 -0.00012207 0.00012207 8.95418 0.00012207 19.9999C0.00012207 31.0456 8.95443 39.9999 20.0001 39.9999Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1739 13.0435H38.7559C35.9302 5.4275 28.5992 0 20 0C14.477 0 9.47758 2.23898 5.85852 5.85852L12.1739 13.0435Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1739 26.9564H38.7559C35.9302 34.5724 28.5992 39.9999 20 39.9999C14.477 39.9999 9.47758 37.761 5.85852 34.1414L12.1739 26.9564Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.85785 5.85779C-1.95262 13.6683 -1.95262 26.3316 5.85785 34.1422C9.08543 30.9146 12.1896 27.8104 20 20L5.85785 5.85779Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.93801 15.6522L9.03559 17.9475L11.5144 17.3746L10.4043 19.6637L12.3976 21.2445L9.91582 21.8038L9.92269 24.3478L7.93801 22.7562L5.95324 24.3478L5.96019 21.8038L3.47839 21.2445L5.47168 19.6637L4.36168 17.3746L6.84035 17.9475L7.93801 15.6522Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_763"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJordan);
export default __webpack_public_path__ + "static/media/jordan.7f9a0ec9710a445ae80b26c226942c3d.svg";
export { ForwardRef as ReactComponent };